import { render, staticRenderFns } from "./DentalHospitals.vue?vue&type=template&id=ca9ab630&scoped=true"
import script from "./DentalHospitals.vue?vue&type=script&lang=js"
export * from "./DentalHospitals.vue?vue&type=script&lang=js"
import style0 from "./DentalHospitals.vue?vue&type=style&index=0&id=ca9ab630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9ab630",
  null
  
)

export default component.exports